import axios from "../utils/axios";

// ============================================
// GET NOTIFICATIONS
// ============================================
export const getNotificationsApi = (params = {}) => {
  const { page = 1, limit = 20, type, read, role } = params;
  let url = `/api/notifications?page=${page}&limit=${limit}`;
  
  if (type) url += `&type=${type}`;
  if (read !== undefined) url += `&read=${read}`;
  if (role) url += `&role=${role}`;
  
  return axios.get(url);
};

// ============================================
// GET UNREAD COUNT
// ============================================
export const getUnreadCountApi = (role = null) => {
  const url = role ? `/api/notifications/unread-count?role=${role}` : '/api/notifications/unread-count';
  return axios.get(url);
};

// ============================================
// MARK NOTIFICATION AS READ
// ============================================
export const markNotificationReadApi = (notificationId) => {
  return axios.put(`/api/notifications/${notificationId}/read`);
};

// ============================================
// MARK ALL NOTIFICATIONS AS READ
// ============================================
export const markAllNotificationsReadApi = (role = null) => {
  const url = role ? `/api/notifications/read-all?role=${role}` : '/api/notifications/read-all';
  return axios.put(url);
};

// ============================================
// DELETE NOTIFICATION
// ============================================
export const deleteNotificationApi = (notificationId) => {
  return axios.delete(`/api/notifications/${notificationId}`);
};